import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function SalonManagementMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.salon.manage.home);
  };

  return (
    <MainMenuItem
      itemTitleString="美容室の管理"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default SalonManagementMenuItem;
